// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fx-0";
export var headerCellHover = "_fx-1";
export var readCellContainer = "_fx-2";
export var unreadIndicator = "_fx-3";